import { Injectable } from '@angular/core';
import type { Producto } from '../types/product.types';

@Injectable({
  providedIn: 'root',
})
export class ProductUtilsService {
  /**
   * Obtiene los años de garantía según la marca
   */
  getWarrantyYears(brand: string): number {
    const warrantyMap: Record<string, number> = {
      'TAB POLAR': 3,
      'TAB 5G': 4,
      'TAB AGM STOP & GO': 5,
    };

    return warrantyMap[brand] || 0;
  }

  /**
   * Calcula el inventario total del producto
   */
  getTotalInventory(product: Producto): number {
    return product.inventarios.reduce((acc, curr) => acc + curr.cantidad, 0);
  }

  /**
   * Obtiene los atributos que deben mostrarse en la interfaz
   */
  getDisplayableAttributes(product: Producto) {
    return product.atributos.filter(
      (attribute) => attribute.filterable && !attribute.is_from_api_catalogo
    );
  }

  /**
   * Obtiene la descripción SEO del producto
   */
  getSeoDescription(product: Producto): string {
    const atributo = product.atributos.find((atr) => atr.id_definition === 151);
    return atributo?.value || '';
  }

  /**
   * Obtiene la primera imagen del producto
   */
  getFirstImage(product: Producto): string {
    return product.imagenes?.xl?.[0] || '';
  }

  /**
   * Verifica si el producto tiene imágenes
   */
  hasImages(product: Producto): boolean {
    return !!(product.imagenes?.xl && product.imagenes.xl.length > 0);
  }

  /**
   * Obtiene la URL de imagen por defecto
   */
  getDefaultImageUrl(): string {
    return 'https://www.allasrepuestos.com/logos/isotipo.webp';
  }

  /**
   * Obtiene la URL de la imagen del producto para SEO
   */
  getProductImageUrl(product: Producto): string {
    return (
      product.imagenes?.xl?.[0] ||
      'https://www.allasrepuestos.com/logos/isotipo.webp'
    );
  }
}
